class DeleteIdentityProvider {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default DeleteIdentityProvider;
